import React from 'react';
import { Radio, Input, Row, Col, message } from 'antd'
import { InputType } from './input-const';

const RadioGroup = Radio.Group;
const { TextArea } = Input;

/**
 * 单选框输入控件配置组件
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 19:21:51
 * Version: 1.0
 * Modify log:
 */
class SettingRadio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '', //原参数json字符串
            radioLabels: '', //label textarea文本域的值
            radioValues: '', //value textarea文本域的值
            featureParams: {
                type: InputType.RADIO, //控件类型，必须有此属性，用于渲染时期判断控件类型
                options: [],
                required: false, //是否必须
                defaultValue: '' //默认值
            }
        }
    }

    static defaultProps = {
        initFeature: ''
    }

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                if (initFeature.type == InputType.RADIO) {
                    let { options = [], required = false, defaultValue = '' } = initFeature;

                    let radioLabels = '';
                    let radioValues = '';
                    for (let radioParam of options) {
                        radioLabels += radioParam.label + ",";
                        radioValues += radioParam.value + ",";
                    }

                    if (radioLabels.length > 0) {
                        radioLabels = radioLabels.substring(0, radioLabels.length - 1);
                    }
                    if (radioValues.length > 0) {
                        radioValues = radioValues.substring(0, radioValues.length - 1);
                    }

                    const fp = { ...this.state.featureParams };
                    fp.options = options;
                    fp.required = required;
                    fp.defaultValue = defaultValue;

                    this.setState({
                        feature: this.props.initFeature,
                        radioLabels: radioLabels,
                        radioValues: radioValues,
                        featureParams: fp
                    });
                }

            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        } else {
            try {
                let feature = JSON.stringify(this.state.featureParams);
                this.setState({
                    feature: feature
                });
            } catch (e) {
                console.log(e);
                message.error('生成控件配置参数出错！');
            }
        }
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //单选框标签值
    handleRadioLabelChange = (e) => {
        let labels = e.target.value;
        let labelArray = [];
        if (labels.length > 0) {
            //去除末尾的中英文逗号
            let endChar = labels.charAt(labels.length - 1);
            let tempLabels = labels;
            if (endChar == ',' || endChar == '，') {
                tempLabels = tempLabels.substring(0, labels.length - 1);
            }
            labelArray = tempLabels.trim().split(/,|，/);
            console.info(labelArray);
        }

        if (labelArray.length > 0) {

            let values = this.state.radioValues;
            let valueArray = [];
            if (values.length > 0) {
                //去除末尾的中英文逗号
                let endChar = values.charAt(values.length - 1);
                if (endChar == ',' || endChar == '，') {
                    values = values.substring(0, values.length - 1);
                }
                valueArray = values.trim().split(/,|，/);
            }

            const fp = { ...this.state.featureParams };
            fp.options.splice(0, fp.options.length);

            //当label的个数与value不相等时，以较少的为准，多余的将不纳入参数
            let indexRange = labelArray.length > valueArray.length ? valueArray.length : labelArray.length;

            //构建radio的options值，方便render以options形式渲染单选框
            for (let index = 0; index < indexRange; index++) {
                let option = {};
                option.label = labelArray[index];
                option.value = valueArray[index];
                fp.options.push(option);
            }
            this.setState({ featureParams: fp });
            this.createFeature(fp);
        }
        this.setState({ radioLabels: labels });
    }

    //单选框真实值
    handleRadioValueChange = (e) => {
        let values = e.target.value;
        let valueArray = [];
        if (values.length > 0) {
            //去除末尾的中英文逗号
            let endChar = values.charAt(values.length - 1);
            let tempValues = values;
            if (endChar == ',' || endChar == '，') {
                tempValues = tempValues.substring(0, values.length - 1);
            }
            valueArray = tempValues.trim().split(/,|，/);
            console.info(valueArray);
        }

        if (valueArray.length > 0) {

            let labels = this.state.radioLabels;
            let labelArray = [];
            if (labels.length > 0) {
                //去除末尾的中英文逗号
                let endChar = labels.charAt(labels.length - 1);
                if (endChar == ',' || endChar == '，') {
                    labels = labels.substring(0, labels.length - 1);
                }
                labelArray = labels.trim().split(/,|，/);
            }

            const fp = { ...this.state.featureParams };
            fp.options.splice(0, fp.options.length);

            //当label的个数与value不相等时，以较少的为准，多余的将不纳入参数
            let indexRange = labelArray.length > valueArray.length ? valueArray.length : labelArray.length;

            //构建radio的options值，方便render以options形式渲染单选框
            for (let index = 0; index < indexRange; index++) {
                let option = {};
                option.label = labelArray[index];
                option.value = valueArray[index];
                fp.options.push(option);
            }
            this.setState({ featureParams: fp });
            this.createFeature(fp);
        }
        this.setState({ radioValues: values });
    }

    //是否必填
    handleRequiredRadioChange = (e) => {
        let required = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.required = required;

        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //默认值
    handleDefaultValueChange = (e) => {
        let defaultValue = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.defaultValue = defaultValue;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //生成feature参数json字符串
    createFeature = (featureParams) => {

        try {
            let feature = JSON.stringify(featureParams);
            this.setState({
                feature: feature
            });
            this.props.onChange(feature);
        } catch (e) {
            console.log(e);
            message.error('生成控件配置参数出错！');
        }
    }

    render() {

        let radioLabels = this.state.radioLabels;
        let radioValues = this.state.radioValues;
        let { required, defaultValue } = this.state.featureParams;

        return (
            <div id="input-setting-div">
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>单选框配置信息</div></Col>
                </Row>
                <Row type="flex" gutter={8}>
                    <Col span={12}>
                        <div style={{ marginBottom: "5px" }}>单选框标签</div>
                        <TextArea
                            rows={3}
                            placeholder="请输入一组单选框标签，以逗号','隔开。如：'标签1,标签2,标签3'，不宜超过5项"
                            onChange={this.handleRadioLabelChange}
                            value={radioLabels}
                        />
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: "5px" }}>单选框值</div>
                        <TextArea
                            rows={3}
                            placeholder="请输入一组单选框值，以逗号','隔开。如：'值1,值2,值3'，不宜超过5项"
                            onChange={this.handleRadioValueChange}
                            value={radioValues}
                        />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>是否必填</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleRequiredRadioChange} name="requiredradiogroup"
                            value={required}>
                            <Radio value={false}>
                                非必填
                            </Radio>
                            <Radio value={true}>
                                必填
                            </Radio>
                        </RadioGroup>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col span={24}><div style={{ margin: "16px 0" }}>默认值</div></Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <Input placeholder="请输入默认选中项的值" onChange={this.handleDefaultValueChange} value={defaultValue} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SettingRadio;


// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-radio.js